var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNews = function SvgNews(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4 8.72c-.37-.21-.83-.21-1.2 0L9.52 14.6l10.66 5.89c.38.2.84.2 1.22 0l10.66-5.89-10.66-5.88Zm-2.42-2.25a3.75 3.75 0 0 1 3.64 0l10.66 5.88a2.57 2.57 0 0 1 0 4.5l-1.72.95 1.72.95a2.57 2.57 0 0 1 0 4.5l-1.72.95 1.72.95a2.57 2.57 0 0 1 0 4.5l-10.66 5.88c-1.14.63-2.5.63-3.64 0L8.32 29.65a2.57 2.57 0 0 1 0-4.5l1.72-.95-1.72-.95a2.57 2.57 0 0 1 0-4.5l1.72-.95-1.72-.95a2.57 2.57 0 0 1 0-4.5l10.66-5.88Zm-6.3 12.79L9.53 21l10.66 5.89c.38.2.84.2 1.22 0L32.07 21l-3.15-1.74-6.3 3.47c-1.14.63-2.5.63-3.64 0l-6.3-3.47Zm0 6.4L9.53 27.4l10.66 5.88c.38.21.84.21 1.22 0l10.66-5.88-3.15-1.74-6.3 3.47c-1.14.63-2.5.63-3.64 0l-6.3-3.47Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNews);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news.60b7bab8d2902586763fb45d64489166.svg";